import React from 'react'
import { Edit } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'

import type { DoneUploadItem } from '../PatientFilesUpload'

type Props = {
  item: DoneUploadItem
  onStartRename: (item: DoneUploadItem) => void
}

const FilenameDisplay = ({ item, onStartRename }: Props) => (
  <Box display="flex" alignItems="center" gap={0.5}>
    <Typography variant="body2">{item.file.filename}</Typography>
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation()
        onStartRename(item)
      }}
    >
      <Edit fontSize="small" />
    </IconButton>
  </Box>
)

export default FilenameDisplay
